export enum FileValidationComponentEnum {
    PRICE = 'PRICE',
    ASSISTANT = 'ASSISTANT',
    BATCH_PRICER = 'BATCH_PRICER',
}
